import Breadcrumb from './Breadcrumb';
import BreadcrumbItem from './BreadcrumbItem';
import BreadcrumbSeparator from './BreadcrumbSeparator';
Breadcrumb.Item = BreadcrumbItem;
Breadcrumb.Separator = BreadcrumbSeparator;
export default Breadcrumb;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/breadcrumb/index.js
// module id = 316
// module chunks = 0